import { removeSection } from '@inter-ikea-storageone/range-boaxel';
import { BehaviorParameters } from 'rangeConfig/@types';

const deleteSection = ({ coreApi }: BehaviorParameters) => {
  const selectedEntity = coreApi.entities.findSelectedEntity();

  if (!selectedEntity) return;

  removeSection(selectedEntity);
};

export default deleteSection;
